module.exports = __webpack_public_path__ + "static/img/loginlogo.e1dbf56.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/loginlogo.png
// module id = GYjj
// module chunks = 1